/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type NextStatusComparison_tradeFirm$ref = any;
type PointsSummary_tradeFirm$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TpnOverview_tradeFirm$ref: FragmentReference;
export type TpnOverview_tradeFirm = {|
  +$fragmentRefs: NextStatusComparison_tradeFirm$ref & PointsSummary_tradeFirm$ref,
  +$refType: TpnOverview_tradeFirm$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "TpnOverview_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "NextStatusComparison_tradeFirm",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PointsSummary_tradeFirm",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a53451bd0f13740e7b28b8c23a280bec';
module.exports = node;
